var React = require('react');

function Shuttle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Shuttle"),React.createElement("path",{"id":"path1520","className":"cls-1","d":"M114,76.5H97.33l-25-25H55.67l-25,25H14","key":2})]);
}

Shuttle.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Shuttle;

Shuttle.default = Shuttle;
